import { z } from 'zod/v4';

export const CancelCompanyDocumentRequestParamsSchema = z.object({
  id: z.string().min(1),
});

export type CancelCompanyDocumentRequestParams = z.infer<
  typeof CancelCompanyDocumentRequestParamsSchema
>;
